import React from "react";
import { useTranslation } from "react-i18next";

function LoginLayout({ children }: { children: React.ReactNode }) {
	const { t } = useTranslation();
	return (
		<div className="app app--login" role="main">
			<div className="bg-overlay" />
			<div className="col login-wrapper">
				<div className="login">
					<div className="card login__card">
						<div className="card-body d-flex flex-column">
							<h1 className="sr-only">{t("main.login.login")}</h1>
							{children}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default LoginLayout;
